import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function PaymentSuccessful() {
  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <div style={{ textAlign: "center" }}>
        <h2 className="mb-4">Plaćanje uspješno!</h2>
        <p>
          Povratak na{" "}
          <Link to="/dashboard">
            <Button variant="primary">Dashboard</Button>
          </Link>
        </p>
      </div>
    </Container>
  );
}

export default PaymentSuccessful;
